import { render, staticRenderFns } from "./SttDictionaryAdd.vue?vue&type=template&id=ea19c030&scoped=true"
import script from "./SttDictionaryAdd.vue?vue&type=script&lang=js"
export * from "./SttDictionaryAdd.vue?vue&type=script&lang=js"
import style0 from "./SttDictionaryAdd.vue?vue&type=style&index=0&id=ea19c030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea19c030",
  null
  
)

export default component.exports